module.exports = __webpack_public_path__ + "static/media/Home-h.f8781397.png";